var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useContext } from "react";
import { BigNumber } from "ethers";
import { VaultVersionList } from "../constants/constants";
import { SubgraphDataContext } from "./subgraphDataContext";
import { isSolanaChain } from "../utils/chains";
export var transactionsGraphql = function (account, chain) { return "\n  vaultTransactions(\n    " + (isSolanaChain(chain)
    ? "where:{address:{_eq:\"" + account + "\"}}"
    : "where:{address:\"" + account + "\"}") + ",\n    " + (isSolanaChain(chain)
    ? "order_by: { timestamp: desc }"
    : "orderBy: timestamp,\n           orderDirection: desc") + "\n  ) {\n    id\n    type\n    vault {\n      id\n      symbol\n    }\n    amount\n    underlyingAmount\n    address\n    txhash\n    timestamp\n  }\n"; };
export var resolveTransactionsSubgraphResponse = function (responses) {
    return VaultVersionList.flatMap(function (version) {
        return responses[version] && responses[version].vaultTransactions
            ? responses[version].vaultTransactions.map(function (transaction) { return (__assign(__assign({}, transaction), { amount: BigNumber.from(transaction.amount), underlyingAmount: BigNumber.from(transaction.underlyingAmount), vaultVersion: version })); })
            : [];
    });
};
export var useTransactions = function () {
    var contextData = useContext(SubgraphDataContext);
    return {
        vaultsTotalPrice: contextData.vaultSubgraphData.vaultsTotalPrice,
        transactions: contextData.vaultSubgraphData.transactions,
        loading: contextData.vaultSubgraphData.loading,
    };
};
export default useTransactions;
//# sourceMappingURL=useTransactions.js.map